// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class SectionProductCarousel extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector(
      '[data-el="section-product-carousel.slides"]'
    )
    this.slideEls = this.querySelectorAll(
      '[data-el="section-product-carousel.slide"]'
    )
    this.progressEl = this.querySelector(
      '[data-el="section-product-carousel.progress"]'
    )
    this.arrowNextEls = this.querySelectorAll(
      '[data-el="section-product-carousel.controlnext"]'
    )
    this.arrowPrevEls = this.querySelectorAll(
      '[data-el="section-product-carousel.controlprevious"]'
    )

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()

    this.arrowNextEls.forEach(arrowNextEl => {
      arrowNextEl.addEventListener('click', this.changeCarousel.bind(this))
    })
    this.arrowPrevEls.forEach(arrowPrevEl => {
      arrowPrevEl.addEventListener('click', this.changeCarousel.bind(this))
    })
  }

  initialiseCarousel () {
    return new KeenSlider(this.slidesEl, {
      duration: 1000,
      centered: false,
      loop: false,
      mode: 'free',
      slides: '.car-Carousel_Slide',
      slidesPerView: 1.6,
      spacing: 10,
      breakpoints: {
        '(min-width: 768px)': {
          loop: true,
          mode: 'snap',
          slidesPerView: 2.4,
        },
        '(min-width: 900px)': {
          loop: true,
          mode: 'snap',
          slidesPerView: 3.4,
        },
        '(min-width: 1200px)': {
          loop: true,
          mode: 'snap',
          slidesPerView: 4.5,
        },
      },
      move: instance => {
        if (this.progressEl) {
          const progressTrack = instance.details().progressTrack
          const progressAmount = progressTrack >= 0.9 ? 0 : progressTrack
          const movementPercentage = progressAmount * 100
          this.progressEl.style.setProperty('--progress', `${movementPercentage}%`)
        }
      },
    })
  }

  changeCarousel (e) {
    if (e.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('section-product-carousel', SectionProductCarousel)
